import React from 'react'

export function ErrorMessage({ message }: { message: string }) {
  return <div className="text-red text-xs">{message}</div>
}
